var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-shell"},[_c('router-view'),_c('ThemeToggle'),_c('LanguageSelect')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }